import React, { useState, useEffect } from "react";
import axios from "axios"; // Import axios
import "../../components/Department/Department.css";

const Department = ({openProfile,setOpenProfile,tokenStorage, selectedDepartmentId, successMessage, setSuccessMessage }) => {
  // const [departmentData, setDepartmentData] = useState(null);
  const baseAPI = process.env.REACT_APP_API_URL;

  useEffect(() => {
    const storedToken = JSON.parse(localStorage.getItem("token"));
    //console.log(storedToken);
    if (storedToken) {
      axios
        .get(
          `${baseAPI}adminget/GETDepartment?department=` +
            selectedDepartmentId,
          {
            headers: {
              Authorization: `Bearer ${storedToken}`,
            },
          }
        )
        .then((response) => {
          setFirstItem(response.data.data[0]);
        })
        .catch((error) => {
          console.error("Error fetching user detail:", error);
        });
    }
  }, []);

  const [firstItem, setFirstItem] = useState({
    dept_id: selectedDepartmentId,
    department: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    
    setFirstItem((prevItem) => ({
      ...prevItem,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setFirstItem({
      dept_id: selectedDepartmentId,
    });
    try {
      const storedToken = JSON.parse(localStorage.getItem("token"));
      // Make a POST request to your API endpoint
      const response = await axios.post(
        `${baseAPI}adminpost/AddDepartment`,
        firstItem, // Send formData as the request body
        {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        }
      );

      

      //to show success message
      setSuccessMessage("Data successfully saved");

      // Optionally, reset the form
      setFirstItem({
        department: "",
      });
      tokenStorage();
      setOpenProfile (!openProfile); 
    } catch (error) {
      // Handle errors (e.g., show an error message)
      console.error("Error posting data:", error);
    }
  };

  return (
    <div className="container-fluid">
      <br />
      <div className="departmentDetail">
      {successMessage && (
          <div style={{ color: "green" }}>{successMessage}</div>
        )}  
          <form className="department-form">
            <table style={{ width: "100%" }}>
              <tr className="space">
                <td colSpan={3}></td>
              </tr>
              <tr className="tableHeading">
                <td>Department Name*</td>
              </tr>
             
                  <tr key={firstItem.dept_id}>
                    <td>
                      <input name="department" value={firstItem.department} onChange={handleChange}/>
                    </td>
                  </tr>
               
              <tr className="space">
                <td colSpan={3}></td>
              </tr>
            </table>
            <br />
            <hr />
            <div className="reset-addDepartment-button">
              <button
                type="submit"
                onClick={handleSubmit}
                style={{
                  marginRight: "10px",
                  backgroundColor: "#5B489D",
                  color: "white",
                }}
              >
                Apply
              </button>
              <button style={{ backgroundColor: "#F15843", color: "white" }}>
                Reset
              </button>
            </div>
          </form>        
      </div>
      <br />
    </div>
  );
};

export default Department;
